export default __webpack_public_path__ + "static/media/close_tag.c7aca332.svg";